import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    saveFiltersAction: (state, action) => {
      const { filterType, filterValue } = action.payload;
      return { ...state, [filterType]: filterValue };
    },
    deleteFiltersAction: () => {
      return null;
    },
  },
});

// Action creators
export const { saveFiltersAction, deleteFiltersAction } = filterSlice.actions;

// Thunks
export const saveFilters = (filterType, filterValue) => (dispatch) => {
  dispatch(saveFiltersAction({ filterType, filterValue }));
};

export const deleteFilters = () => (dispatch) => {
  dispatch(deleteFiltersAction());
};

export default filterSlice.reducer;
